const Videos = (): JSX.Element => (
  <svg
    width="23px"
    height="23px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.003 3.287v13.427L15.05 10 3.003 3.287ZM.62 3.103C.62 1.367 2.486.27 4.002 1.115L16.38 8.013c1.557.868 1.557 3.107 0 3.975L4.002 18.886C2.486 19.73.62 18.634.62 16.898V3.102Z"
      fill="currentColor"
    />
  </svg>
);

export default Videos;
